import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button } from '@dorixona/ui'
import { Icon } from '../ui/Icon'

export function NotFoundPage() {
  const { t } = useTranslation('common')
  const navigate = useNavigate()

  return (
    <section className="screen">
      <div className="mhead">
        <h1>{t('state.notFound')}</h1>
      </div>
      <div className="card empty">
        <Icon name="i-search" size={54} />
        <div className="t">{t('state.notFound')}</div>
        <div style={{ marginTop: 18 }}>
          <Button
            onPress={() => {
              void navigate('/')
            }}
          >
            {t('tabs.home')}
          </Button>
        </div>
      </div>
    </section>
  )
}
